import React from "react";
import { Link } from "react-router-dom";
import { Divider } from "@mui/material";
import { PersonInfoFilled } from "@fluentui/react-icons";
import DisclaimerIcon from "../../../assets/Disclaimer.svg";
import i18next from "../../../i18n/i18n";
import styles from "../Chat.module.css";
import { userInfo } from "../../../authConfig";

interface DisclaimerScreenProps {
    sessionStatus: string;
    onDismiss: () => void;
    isClarificationVisible?: boolean;
}

export const DisclaimerScreen: React.FC<DisclaimerScreenProps> = ({ sessionStatus, onDismiss, isClarificationVisible = false }) => {
    if (sessionStatus !== "initial") {
        return null;
    }

    const listClass = userInfo.locale === "ja" || userInfo.locale === "zh" ? styles.disclaimerListSmall : styles.disclaimerListNormal;

    return (
        <div
            className={`${styles.disclaimerContainer} ${styles.disclaimerHeight} ${isClarificationVisible ? styles.disclaimerHeightWithClarification : ""}`.trim()}
        >
            <p className={styles.disclaimerHeader}>
                <img src={DisclaimerIcon} alt="Icon" className={styles.disclaimerIcon} />
                <span>
                    {i18next.t("chat.guideHeader1")}
                    <Link id="UserGuidlines" to="/assistant/guide" target="_blank" className={styles.disclaimerLink}>
                        {i18next.t("chat.guideHeader2")}
                    </Link>
                    {i18next.t("chat.guideHeader3")}
                </span>
            </p>

            <Divider />
            <div className={styles.disclaimerInnerContainer}>
                <p className={styles.disclaimerInnerTitle}>
                    <PersonInfoFilled /> {i18next.t("chat.disclaimerHeading")}
                </p>
                <ol className={listClass}>
                    <li>
                        <p className={styles.disclaimerListItemHeader}>{i18next.t("chat.disclaimerList1Header")}</p>:
                        <p className={styles.disclaimerListItemText}>{i18next.t("chat.disclaimerList1")}</p>
                    </li>
                    <li>
                        <p className={styles.disclaimerListItemHeader}>{i18next.t("chat.disclaimerList2Header")}</p>:
                        <p className={styles.disclaimerListItemText}>{i18next.t("chat.disclaimerList2")}</p>
                    </li>
                    <li>
                        <p className={styles.disclaimerListItemHeader}>{i18next.t("chat.disclaimerList3Header")}</p>:
                        <p className={styles.disclaimerListItemText}>{i18next.t("chat.disclaimerList3")}</p>
                    </li>
                    <li>
                        <p className={styles.disclaimerListItemHeader}>{i18next.t("chat.disclaimerList4Header")}</p>:
                        <p className={styles.disclaimerListItemText}>{i18next.t("chat.disclaimerList4")}</p>
                    </li>
                    <li>
                        <p className={styles.disclaimerListItemHeader}>{i18next.t("chat.disclaimerList5Header")}</p>:
                        <p className={styles.disclaimerListItemText}>{i18next.t("chat.disclaimerList5")}</p>
                    </li>
                    <li>
                        <p className={styles.disclaimerListItemHeader}>{i18next.t("chat.disclaimerList6Header")}</p>:
                        <p className={styles.disclaimerListItemText}>{i18next.t("chat.disclaimerList6")}</p>
                    </li>
                    <li>
                        <p className={styles.disclaimerListItemHeader}>{i18next.t("chat.disclaimerList7Header")}</p>:
                        <p className={styles.disclaimerListItemText}>{i18next.t("chat.disclaimerList7")}</p>
                    </li>
                    <li>
                        <p className={styles.disclaimerListItemHeader}>{i18next.t("chat.disclaimerList8Header")}</p>:
                        <p className={styles.disclaimerListItemText}>{i18next.t("chat.disclaimerList8")}</p>
                    </li>
                </ol>
            </div>
        </div>
    );
};
